import React from "react";

import WidgetContainer from "compid/shared/containers/WidgetContainer";
import WidgetView, { WidgetMainContentView } from "compid/shared/views/WidgetView";
import UIButton from "compid/ui/UIButton";

import { useMultiPay } from "compid/workflows/MultiPay";
import './styles.css';

/**
 * @function MultipayWidget
 * @param {ARRAY} bills - The bills that are shown in the multipay
 * @param {ARRAY} items - The items that are to be shown in the table
 * @param {FUNCTION} onSubmit - The function to be ran when the submit button is clicked
 * @param {FUNCTION} onCancel - The function to be ran when the cancel button is clicked
 * @returns {React.Component}
 * @exported true
 * @description The main multipay component
 */
export default function MultipayNotice(props) {
  const { state = [], reset } = useMultiPay() ?? {};
  const isDisabled = state.length === 0;

  return(
    <WidgetContainer className="multipay-notice-widget">
      <WidgetView>
        <WidgetMainContentView>

          {/* When no bills are selected this shows - This is shown by default */}
          <div className={ `flex-width flex-container flex-horizontal` }>
            <div className="flex-width flex-container flex-vertical text-container">
              <div className="flex-height">
                <h4>Need to make multiple payments?</h4>
              </div>
              
              <div className="flex-height">
                <p className="sub-text">Check the box to the left of each biller and as many as necessary. Once you are done selecting billers, select "Pay selected billers" button to review and make payment or press Clear all button to unselect.</p>
              </div>
            </div>

            <div className="set-width clear-btn-container">
              <UIButton className={ `secondary-button ${ isDisabled ? "disabled-gray" : "" }` } onClick={ reset }>Clear all</UIButton>
            </div>
          </div>

        </WidgetMainContentView>
      </WidgetView>
    </WidgetContainer>
  );
}
